import React, { useEffect, useState } from 'react'
import { TreeStandards } from 'components/tree/standardUtilities'
import { Box } from '@mui/material'
import { VerifyStandards } from './VerifyStandards'
import { useGetTreeById } from '../../reducers/trees_hooks'

export function StandardsInfo({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree, resetTree } = useGetTreeById({ treeId, versionId })
  const [countUserGenerated, setCountUserGenerated] = React.useState<number>()
  const [countState, setCountState] = useState<{
    [key: string]: number
  }>({})

  useEffect(() => {
    if (!tree) return
    TreeStandards.create(tree).then((treeStandards) => {
      setCountUserGenerated(treeStandards.countUserGenerated)
      setCountState(treeStandards.stateStandardsCount())
    })
  }, [tree])

  if (!tree || !resetTree) return <Box>Loading...</Box>

  return (
    <Box>
      <Box>{countUserGenerated} User Generated Standards</Box>
      {Object.keys(countState).map((state, i) => {
        return (
          <Box key={i}>
            {countState[state]} {state} Standards
          </Box>
        )
      })}
      <VerifyStandards tree={tree} reFetchTree={resetTree} />
    </Box>
  )
}
